/**
 * Mise à jour de l'application restée ouverte.
 *
 * Le service worker (vite-plugin-pwa, `autoUpdate`) installe une nouvelle version en arrière-plan, mais un onglet déjà
 * ouvert garde l'ancien code : il peut alors mal afficher des données d'une API plus récente. On vérifie donc les mises
 * à jour à chaque retour sur l'onglet, et on recharge au retour suivant une installation — jamais pendant la lecture.
 * Rien à perdre : l'application n'a pas de saisie en cours.
 */
export function reloadOnReturnAfterUpdate(): void {
  const sw = typeof navigator === 'undefined' ? undefined : navigator.serviceWorker;
  if (sw === undefined) return;
  // Une page sans contrôleur au départ reçoit son premier service worker : ce n'est pas une mise à jour.
  const wasControlled = sw.controller !== null;
  let updated = false;

  sw.addEventListener('controllerchange', () => {
    if (wasControlled) updated = true;
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    if (updated) {
      window.location.reload();
      return;
    }
    sw.getRegistration()
      .then((registration) => registration?.update())
      .catch(() => {
        // Hors ligne ou serveur indisponible : on réessaiera au prochain retour.
      });
  });
}
